import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useNavigate, useParams } from 'react-router-dom'
import ReactGA from 'react-ga4'

import Loading from '@components/loading'
import TablePageHandler from '@components/table/tablePageHandler'
import colors from '@settings/styleSettings'
import LoadingModal from '@components/loading/loadingModal'
import BeneficiaryTable from '@components/table/beneficiaryTable'
import CharacteristicCard from '@components/characteristicCard'
import ClassificationMetrics from '@components/classificationMetrics'
// import MessageHistoryPanel from '@components/messageHistoryPanel'

import CompaniesList from './companiesList'
import ProgrammesList from './programmesList'
import CompaniesFilter from './companiesFilter'
import ProgrammeFilter from './programmeFilter'
import Header from './header'

import AuthUtil from '@util/AuthUtil'
import {
  Container,
  SearchContainer,
  LoadingContainer,
  Title,
  PanelContainer,
} from './styles'
import { getCompanies as getCompaniesAction } from '@actions/company'
import { getBeneficiariesWithCollection as getBeneficiariesAction } from '@actions/beneficiary'
import { getProgrammes as getProgrammesAction } from '@actions/programme'
import { listMessages as listMessagesAction } from '@actions/notification'

const defaultPageSize = 10

const Companies = ({
  getBeneficiariesWithCollection,
  companyTotal,
  programmeTotal,
  getCompanies,
  getProgrammes,
  companies,
  programmes,
  authData,
  listMessages,
}) => {
  const [companyPage, setCompanyPage] = useState(0)
  const [companyPageSize, setCompanyPageSize] = useState(defaultPageSize)
  const [programmePage, setProgrammePage] = useState(0)
  const [programmePageSize, setProgrammePageSize] = useState(defaultPageSize)
  const [loadingCompanies, setLoadingCompanies] = useState(false)
  const [loadingProgrammes, setLoadingProgrammes] = useState(false)
  const [companySearchTerm, setCompanySearchTerm] = useState('')
  const [programmeSearchTerm, setProgrammeSearchTerm] = useState('')
  const [beneficiaryFilterState, setBeneficiaryFilterState] = useState({
    highRisk: false,
    mediumRisk: false,
    lowRisk: false,
    noRisk: false,

    diabetic: false,
    amputation: false,
    diabeticFoot: false,
    nephropathy: false,
    type2: false,
    controlledGlycatedHemoglobin: false,
    diabeticFootEvaluated: false,
    alcohol: false,
    smoking: false,

    dyslipidemic: false,
    hypertensive: false,
    controlledHypertension: false,

    overweight: false,
    overweightInRecovery: false,

    activeAccounts: false,
    frequentAccessApp: false,
    activeLoans: false,
    diabeticsWithGlucometer: false,
    equipmentInUse: false
  })
  const [companyFilterState, setCompanyFilterState] = useState({})
  const [programmeFilterState, setProgrammeFilterState] = useState({})
  const [, setLoadingMessages] = useState(false)
  const [reportLoading, setReportLoading] = useState(false)

  const { insurance } = useParams()

  const navigate = useNavigate()
  if (!AuthUtil.getAccessToken()) {
    navigate(`/${insurance}/acompanhamento`)
  }

  const searchBeneficiaries = (
    searchTerm,
    newPage,
    newPageSize = defaultPageSize,
    callback
  ) => {
    getBeneficiariesWithCollection(
      {
        page: newPage,
        ...beneficiaryFilterState,
        searchTerm,
        pageSize: newPageSize,
      },
      () => callback && callback()
    )
  }

  const searchCompanies = (newPage, newPageSize = companyPageSize) => {
    if (authData) {
      setLoadingCompanies(true)
      getCompanies(
        {
          page: newPage + 1,
          ...companyFilterState,
          searchTerm: companySearchTerm,
          pageSize: newPageSize,
        },
        () => setLoadingCompanies(false)
      )
      setCompanyPage(newPage)
    }
  }

  const searchProgrammes = (newPage, newPageSize = programmePageSize) => {
    if (authData) {
      setLoadingProgrammes(true)
      getProgrammes(
        {
          page: newPage + 1,
          ...programmeFilterState,
          searchTerm: programmeSearchTerm,
          pageSize: newPageSize,
        },
        () => setLoadingProgrammes(false)
      )
      setProgrammePage(newPage)
    }
  }

  useEffect(() => {
    setLoadingCompanies(true)
    setLoadingProgrammes(true)
    getProgrammes()
    getCompanies()
    setLoadingMessages(true)
    listMessages(
      {
        pageSize: 4,
        page: 0,
        orderByDesc: true,
        orderByAsc: false,
        programmeId: 0,
        companyId: 0,
      },
      () => setLoadingMessages(false)
    )
  }, [])

  useEffect(() => {
    setLoadingCompanies(true)
    searchCompanies(companyPage, companyPageSize)
  }, [companyPage])

  useEffect(() => {
    setLoadingProgrammes(true)
    searchProgrammes(programmePage, programmePageSize)
  }, [programmePage])

  useEffect(() => {
    setLoadingCompanies(true)
    searchCompanies(0, companyPageSize)
  }, [companyPageSize, companyFilterState])

  useEffect(() => {
    setLoadingProgrammes(true)
    searchProgrammes(0, programmePageSize)
  }, [programmePageSize, programmeFilterState])

  const onCompanyInputChange = (e) => setCompanySearchTerm(e.target.value)

  const onProgrammeInputChange = (e) => setProgrammeSearchTerm(e.target.value)

  const renderLoading = () => (
    <LoadingContainer>
      <Loading color={colors.primary} height={40} width={40} />
    </LoadingContainer>
  )

  const onSearchCompany = () => {
    searchCompanies(0, companyPageSize)
  }

  const onSearchProgrammes = () => {
    searchProgrammes(0, programmePageSize)
  }

  const goToCompany = (company) => {
    navigate(`${company.id}`)
  }

  // const goToMessages = () => {
  //   navigate(`/${insurance}/acompanhamento/mensagens`)
  // }

  const goToProgramme = (programme) => {
    ReactGA.event({
      category: 'Acessar programas',
      action: 'Clique em acessar programas',
      label: 'Botão de acessar programas ',
    })
    navigate(`/${insurance}/acompanhamento/programas/${programme.id}`)
  }

  return (
    <Container>
      <Header />
      <SearchContainer>
        <PanelContainer>
          <ClassificationMetrics
            beneficiaryFilter={beneficiaryFilterState}
            setBeneficiaryFilter={setBeneficiaryFilterState}
          />
          {/* <MessageHistoryPanel
            goToMessages={goToMessages}
            loading={loadingMessages}
            slice={4}
          /> */}
        </PanelContainer>
        <Title>Empresas</Title>
        {loadingCompanies ? (
          renderLoading()
        ) : (
          <CharacteristicCard>
            <CompaniesFilter
              onSearch={onSearchCompany}
              searchTerm={companySearchTerm}
              setFilterState={setCompanyFilterState}
              onInputChange={onCompanyInputChange}
            />
            <CompaniesList
              goToCompany={goToCompany}
              filterState={companyFilterState}
              setFilterState={setCompanyFilterState}
              companies={companies}
            />
          </CharacteristicCard>
        )}
        <TablePageHandler
          sizeOnPage={companies && companies.length}
          page={companyPage + 1}
          setPage={setCompanyPage}
          pageSize={companyPageSize}
          setPageSize={setCompanyPageSize}
          total={companyTotal}
        />
        <Title>Programas</Title>
        {loadingProgrammes ? (
          renderLoading()
        ) : (
          <CharacteristicCard>
            <ProgrammeFilter
              onSearch={onSearchProgrammes}
              searchTerm={programmeSearchTerm}
              setFilterState={setProgrammeFilterState}
              onInputChange={onProgrammeInputChange}
            />
            <ProgrammesList
              goToProgramme={goToProgramme}
              filterState={programmeFilterState}
              setFilterState={setProgrammeFilterState}
              programmes={programmes}
            />
          </CharacteristicCard>
        )}
        <TablePageHandler
          sizeOnPage={programmes && programmes.length}
          page={programmePage + 1}
          setPage={setProgrammePage}
          pageSize={programmePageSize}
          setPageSize={setProgrammePageSize}
          total={programmeTotal}
        />
        <Title>Beneficiários</Title>
        <BeneficiaryTable
          onGetReport={(value) => setReportLoading(value)}
          setBeneficiaryFilterState={setBeneficiaryFilterState}
          beneficiaryFilterState={beneficiaryFilterState}
          searchBeneficiaries={searchBeneficiaries}
        />
      </SearchContainer>
      <LoadingModal isOpen={reportLoading} />
    </Container>
  )
}

Companies.propTypes = {
  getBeneficiariesWithCollection: PropTypes.func,
  companyTotal: PropTypes.number,
  programmeTotal: PropTypes.number,
  getCompanies: PropTypes.func.isRequired,
  getProgrammes: PropTypes.func.isRequired,
  companies: PropTypes.arrayOf(PropTypes.shape({})),
  programmes: PropTypes.arrayOf(PropTypes.shape({})),
  authData: PropTypes.object,
  listMessages: PropTypes.func.isRequired
}

Companies.defaultProps = {
  getBeneficiariesWithCollection: () => {},
  companyTotal: 0,
  programmeTotal: 0,
  companies: null,
  programmes: null,
  authData: null,
}

const mapStateToProps = ({
  beneficiary,
  company,
  programme,
  auth,
}) => ({
  beneficiaries: beneficiary.beneficiaries,
  beneficiaryTotal: beneficiary.total,
  companies: company.companies,
  companyTotal: company.total,
  programmes: programme.programmes,
  programmeTotal: programme.total,
  authData: auth.data,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getBeneficiariesWithCollection: getBeneficiariesAction,
    getProgrammes: getProgrammesAction,
    getCompanies: getCompaniesAction,
    listMessages: listMessagesAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(Companies)
